const key = Symbol.for('vm2App.coreSettings');

export const setCoreSettings = (coreSettings) => {
  window[key] = coreSettings;
};

export const getCoreSettings = () => window[key];
